<template>
  <section
    v-if="variants.GoogleReviews === variant || variants.v1 === variant"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <NuxtImg
      v-if="variant === variants.v1"
      :src="vars.backgroundImage"
      class="tw-absolute tw-left-0 tw-top-0 tw-h-full tw-w-full tw-object-cover"
    />
    <div class="tw-absolute tw-inset-0 tw-bg-[--c-primary] tw-opacity-80" v-if="variant === variants.v1"></div>
    <div class="tw-z-10 tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center tw-gap-10">
      <h2 v-if="variant === variants.v1" class="tw-text-center tw-text-white">
        {{ vars.titleText }}
      </h2>
      <div class="tw-flex tw-w-full tw-flex-col tw-gap-6 lg:tw-gap-10">
        <div
          v-if="variant === variants.GoogleReviews"
          v-html="vars.titleHtml"
          class="tw-flex tw-flex-wrap tw-gap-x-4 tw-text-black"
        ></div>
        <Swiper
          :modules="[SwiperPagination]"
          :pagination="false"
          :slides-per-view="1"
          :space-between="30"
          effect="fade"
          :clickable="true"
          :loop="true"
          :breakpoints="computedBreakpoints"
          @slideChange="onSlideChange"
          @swiper="onSwiper"
          class="tw-w-full lg:tw-max-w-full"
        >
          <SwiperSlide v-for="(review, index) in reviews" :key="`testimonials-review-${index}`" class="!tw-h-auto">
            <div
              class="tw-flex tw-h-full tw-w-full tw-flex-col tw-gap-3 tw-rounded tw-bg-white tw-p-10 tw-text-start tw-text-black lg:tw-max-h-[320px]"
              :class="{
                'left-border': variant === variants.GoogleReviews,
              }"
            >
              <template v-if="variant === variants.v1">
                <div class="tw-flex tw-items-center tw-justify-between">
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg
                      v-for="n in review.rating"
                      :key="`testimonials-star-${n}`"
                      width="24"
                      height="24"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 1.25L12.472 7.5H19L13.764 10.972L15.236 17.5L10 13.444L4.764 17.5L6.236 10.972L1 7.5H7.528L10 1.25Z"
                        fill="var(--c-primary)"
                      />
                    </svg>
                  </div>
                  <p v-if="variant === variants.v1">
                    {{ review.date }}
                  </p>
                </div>
                <h4 class="tw-line-clamp-1">{{ review.title }}</h4>
                <p class="tw-max-h-48 tw-overflow-y-auto lg:tw-max-h-40">“{{ review.description }}"</p>
              </template>
              <template v-if="variant === variants.GoogleReviews">
                <div class="tw-flex tw-items-center tw-justify-between">
                  <div class="tw-flex tw-items-center tw-gap-2">
                    <svg
                      v-for="n in review.evaluation_value"
                      :key="`testimonials-star-${n}`"
                      width="24"
                      height="24"
                      viewBox="0 0 20 20"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M10 1.25L12.472 7.5H19L13.764 10.972L15.236 17.5L10 13.444L4.764 17.5L6.236 10.972L1 7.5H7.528L10 1.25Z"
                        fill="var(--c-primary)"
                      />
                    </svg>
                  </div>
                </div>
                <h4 class="tw-line-clamp-1">{{ review.person_name }}</h4>
                <p class="tw-max-h-48 tw-overflow-y-auto lg:tw-max-h-40">“{{ review.content }}"</p>
              </template>
            </div>
          </SwiperSlide>
          <div class="controls">
            <div
              data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569daf"
              class="slide-left-arrow w-slider-arrow-left"
              :isDisabled="!canPaginateBack"
              @click="() => swiper.slidePrev()"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.011 3.49956C16.1418 3.6335 16.2151 3.81332 16.2151 4.00056C16.2151 4.18781 16.1418 4.36762 16.011 4.50156L8.70149 12.0001L16.011 19.4971C16.1418 19.631 16.2151 19.8108 16.2151 19.9981C16.2151 20.1853 16.1418 20.3651 16.011 20.4991C15.9474 20.5644 15.8714 20.6163 15.7874 20.6517C15.7034 20.6872 15.6132 20.7054 15.522 20.7054C15.4308 20.7054 15.3406 20.6872 15.2566 20.6517C15.1726 20.6163 15.0966 20.5644 15.033 20.4991L7.25999 12.5236C7.12347 12.3835 7.04706 12.1957 7.04706 12.0001C7.04706 11.8045 7.12347 11.6166 7.25999 11.4766L15.033 3.50106C15.0966 3.43575 15.1726 3.38383 15.2566 3.34839C15.3406 3.31294 15.4308 3.29468 15.522 3.29468C15.6132 3.29468 15.7034 3.31294 15.7874 3.34839C15.8714 3.38383 15.9474 3.43575 16.011 3.50106V3.49956Z"
                  fill="#6EADAB"
                />
              </svg>
              <div class="slide-circle slider-circle-transform"></div>
            </div>
            <div
              data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569db1"
              class="slide-right-arrow w-slider-arrow-right"
              :isDisabled="!canPaginateNext"
              @click="() => swiper.slideNext()"
            >
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M7.98901 3.49956C7.85817 3.6335 7.78491 3.81332 7.78491 4.00056C7.78491 4.18781 7.85817 4.36762 7.98901 4.50156L15.2985 12.0001L7.98901 19.4971C7.85817 19.631 7.78491 19.8108 7.78491 19.9981C7.78491 20.1853 7.85817 20.3651 7.98901 20.4991C8.0526 20.5644 8.12864 20.6163 8.21263 20.6517C8.29661 20.6872 8.38685 20.7054 8.47801 20.7054C8.56917 20.7054 8.65941 20.6872 8.74339 20.6517C8.82738 20.6163 8.90342 20.5644 8.96701 20.4991L16.74 12.5236C16.8765 12.3835 16.9529 12.1957 16.9529 12.0001C16.9529 11.8045 16.8765 11.6166 16.74 11.4766L8.96701 3.50106C8.90342 3.43575 8.82738 3.38383 8.74339 3.34839C8.65941 3.31294 8.56917 3.29468 8.47801 3.29468C8.38685 3.29468 8.29661 3.31294 8.21263 3.34839C8.12864 3.38383 8.0526 3.43575 7.98901 3.50106V3.49956Z"
                  fill="#6EADAB"
                />
              </svg>
              <div class="slide-circle right"></div>
            </div>
          </div>
        </Swiper>
      </div>
    </div>
  </section>
  <section
    v-else-if="variants.v2 === variant"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center">
      <div v-html="vars.titleHtml" class="tw-mb-6 tw-flex tw-flex-wrap tw-gap-x-4 lg:tw-mb-12"></div>

      <MotionGroup is="div" preset="slideVisibleBottom" :duration="700" class="tw-w-full lg:tw-max-w-full">
        <Swiper
          :pagination="false"
          :slides-per-view="1"
          :space-between="30"
          effect="fade"
          :clickable="true"
          :breakpoints="{
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 32,
            },
          }"
          @slideChange="onSlideChange"
          @swiper="onSwiper"
          class="tw-w-full lg:tw-max-w-full"
        >
          <SwiperSlide v-for="(review, index) in reviews" :key="`testimonials-review-${index}`" class="!tw-h-auto">
            <div
              class="tw-group tw-relative tw-flex tw-h-full tw-min-h-[500px] tw-flex-col tw-border-b-2 tw-border-[var(--c-secondary)] tw-bg-white tw-p-6 tw-duration-500 hover:tw-border-[var(--c-primary)] hover:tw-bg-[var(--c-input)] lg:tw-p-10"
              style="border-radius: var(--rounded)"
            >
              <span class="tw-absolute tw-w-28 tw-self-end">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108.2 61.1">
                  <g id="Layer_1">
                    <path
                      d="M93.7 61.1H14.6C6.6 61.1 0 55.3 0 48.3V12.8C0 5.8 6.6 0 14.6 0h79.1c8 0 14.6 5.8 14.6 12.8v35.5c-.1 7-6.6 12.8-14.6 12.8z"
                      fill="#fff"
                      class="tw-duration-500 group-hover:tw-fill-[var(--c-input)]"
                    />
                    <path
                      d="M27.5 23.3H32c.2 0 .4 0 .4.3.3 2.3 0 4.5-1.1 6.5-1.5 2.7-3.9 4.3-6.9 4.7-3.9.6-7.3-.6-10.1-3.5-3.1-3.4-3.6-8.6-1.2-12.5 1.7-2.8 4.2-4.5 7.5-5.1 3.3-.6 6.3.3 8.9 2.5.2.2.2.3 0 .5-.5.5-1 1-1.5 1.6-.2.2-.3.2-.5 0-4.2-3.7-11.3-1.8-12.6 4.4-.9 4.7 2.2 8.7 6.3 9.3 2.7.4 5.1-.2 6.9-2.4.8-.9 1.1-2 1.3-3.1.1-.3-.2-.3-.4-.3h-6.2c-.4 0-.5-.1-.5-.5v-2c0-.3.1-.4.4-.4h4.8zm49.2-1.7c.3 0 .2.1.2.4v12.2c0 1.1-.2 2.2-.6 3.2-.8 2-2.3 3.1-4.4 3.5-2.2.4-4.1 0-5.8-1.5-.7-.6-1.2-1.3-1.6-2.2-.1-.2-.1-.3.1-.4.7-.3 1.4-.5 2-.8.2-.1.3-.1.5.2.4.8 1 1.5 1.9 1.8 2.3 1 4.7-.2 5.1-2.7.1-.6.1-1.2.1-1.9 0-.1 0-.1-.1-.2-.1 0-.1 0-.2.1-1.9 2.1-5.2 1.8-7.2.2-2.2-1.7-3.2-3.9-2.8-6.7.4-2.7 1.9-4.5 4.5-5.5 2-.7 3.9-.5 5.5 1 .1 0 .1.1.2.1s.1-.5.1-.6c0-.2-.1-.4.2-.4h2.3z"
                      fill="#3074f0"
                    />
                    <path
                      class="st2"
                      d="M55.5 34.9c-3.9 0-6.9-3-6.9-6.9 0-3.9 3-6.9 6.9-6.9 4.1 0 6.9 3.2 6.9 7s-2.9 6.8-6.9 6.8z"
                    />
                    <path
                      d="M33.6 28c0-3.9 3-6.9 6.9-6.9 4 0 6.9 3 6.9 7 0 3.8-3.1 6.8-6.9 6.7-4 .1-6.9-2.9-6.9-6.8zm56.5 6.9c-4.1 0-7.1-3.4-6.7-7.6.2-2 .9-3.7 2.5-4.9 3-2.3 7.1-1.5 9.1 1.8.3.5.6 1.1.8 1.7.1.3.1.4-.2.5-2 .8-4 1.6-6 2.5-.8.4-1.7.7-2.5 1-.3.1-.3.2-.1.5 1.4 2.4 4.8 2.3 6.3.2.2-.3.3-.3.6-.1.6.4 1.1.8 1.7 1.2.2.1.2.2.1.4-1.4 1.8-3.3 2.8-5.6 2.8z"
                      fill="#e63124"
                    />
                    <path
                      d="M82 24.3V34c0 .3 0 .4-.4.4h-2.2c-.4.1-.4 0-.4-.4V14.6c0-.4.1-.5.5-.5h2.1c.3 0 .5.1.5.4-.1 3.4-.1 6.6-.1 9.8z"
                      fill="#249a41"
                    />
                    <path
                      class="st5"
                      d="M21.8 47.1h-1.5c-.2 0-.3-.1-.4-.3-.3-.6-.7-1.3-1.1-1.9-.2-.3-1-.5-1.2-.3-.1.1-.1.2-.1.3v1.9c0 .2-.1.3-.3.3-1.2 0-1.2 0-1.2-1.2v-5.5c0-.3.1-.4.4-.4h3.1c.9 0 1.7.4 2 1.3.3.9.3 1.7-.4 2.5-.2.2-.4.4-.7.4-.3.1-.3.2-.1.4.6.9 1 1.7 1.5 2.5zm22.5-1.8c.3-1 .6-1.9.9-2.9.1-.3.2-.4.5-.4.8 0 .8 0 1.1.8.3.8.6 1.7.9 2.6.3-1.1.6-2 .8-3 .1-.3.2-.4.5-.4 1 0 1 0 .7 1-.4 1.3-.8 2.5-1.2 3.8-.1.3-.2.4-.5.4-1.1 0-1.1 0-1.4-1-.2-.8-.5-1.6-.8-2.4-.2.7-.4 1.3-.6 1.9-.1.4-.3.8-.4 1.3-.1.3-.2.3-.5.3-1.1 0-1.1 0-1.4-1-.4-1.3-.8-2.6-1.2-4v-.1c1.3-.1 1.3-.1 1.7 1.1.4.6.6 1.3.9 2-.1 0-.1 0 0 0zm-4.8-.3H38c-.3 0-.3.1-.2.4.3.7 1 1 1.8.8.2 0 .3-.1.4-.2.5-.2.5-.2.9.3.2.3.1.4-.1.5-1 .5-2 .7-3 .2-1-.4-1.6-1.4-1.5-2.6 0-1.1.7-2 1.7-2.4 1-.4 2.1-.1 2.8.6.5.6.7 1.3.7 2.1 0 .2-.1.3-.3.3h-1.7zm-13.9 0H24c-.3 0-.3.1-.2.3.3.7 1 1.1 1.8.9.2 0 .4-.2.6-.2.1 0 .3-.3.4-.1.2.2.4.5.5.8l-.2.2c-.9.7-2.6.7-3.6.1-1-.7-1.3-2-.9-3.2.4-1.2 1.6-1.9 2.8-1.8 1.2.1 2.1 1.1 2.2 2.3.1.8.1.8-.7.8-.3-.1-.7-.1-1.1-.1zm28.5-1.5c-.4-.3-.8-.5-1.3-.6-.2 0-.5 0-.7.1-.2.1-.4.2-.3.4 0 .2.2.3.4.3.6.2 1.2.2 1.7.5.6.3.9.7 1 1.4 0 .7-.3 1.1-.9 1.4-.1.1-.3.1-.4.1-1 .2-2 .1-2.9-.4-.3-.2-.4-.3-.2-.6.4-.5.3-.5.9-.3.5.3 1 .4 1.6.3.3-.1.5-.2.5-.5s-.2-.4-.5-.5c-.6-.2-1.1-.2-1.7-.4-.5-.2-.9-.6-.9-1.2-.1-.6.2-1.1.7-1.4.3-.2.6-.3 1-.3.8-.1 1.6.1 2.3.5.2.1.3.2.1.5-.2.2-.3.4-.4.7z"
                    />
                    <path
                      class="st2"
                      d="M85.5 47.1c.1-.6.1-1.1.2-1.6.1-.3 0-.4-.2-.6-.4-.4-.7-.7-1.1-1.2.6-.1 1.1-.2 1.6-.3.2 0 .3-.1.4-.3.3-.5.5-.9.8-1.5.3.5.5.9.8 1.4.1.2.3.4.6.4.5.1 1 .2 1.6.3-.4.4-.7.8-1.1 1.2-.2.2-.3.4-.2.6.1.5.1 1 .2 1.6-.5-.3-1-.5-1.5-.7-.2-.1-.3-.1-.5 0-.6.2-1.1.5-1.6.7zm-2.2-3.4c-.4.4-.8.8-1.1 1.2-.2.2-.2.3-.2.6.1.5.1 1.1.2 1.6-.4-.2-.8-.3-1.1-.5-.4-.3-.8-.3-1.3 0-.3.2-.7.3-1.1.5.1-.6.1-1.1.2-1.7 0-.2 0-.4-.2-.5-.4-.4-.7-.8-1.1-1.2.6-.1 1.1-.2 1.6-.3.2 0 .4-.2.5-.4.2-.5.5-.9.8-1.4.3.5.5 1 .8 1.4.1.2.2.3.5.4l1.5.3zm-12.5 0c.6-.1 1.1-.2 1.6-.3.2 0 .4-.1.5-.3.2-.5.5-.9.8-1.4.3.5.5.9.8 1.4.1.2.3.4.6.4.5.1 1 .2 1.6.3-.4.4-.8.8-1.1 1.2-.2.2-.2.3-.2.6.1.5.1 1.1.2 1.6-.5-.2-1-.5-1.5-.7-.2-.1-.4-.1-.6 0-.5.2-.9.4-1.5.7.1-.6.1-1.1.2-1.7 0-.2 0-.4-.2-.5-.5-.4-.8-.8-1.2-1.3zm-6.8 0c.6-.1 1.1-.2 1.6-.3.2 0 .3-.1.4-.3.3-.5.5-.9.8-1.5.3.5.5 1 .8 1.4.1.2.2.3.5.3.5.1 1 .2 1.6.3-.4.4-.7.8-1.1 1.2-.2.2-.3.4-.2.6.1.5.1 1 .2 1.6-.5-.2-1-.5-1.5-.7-.2-.1-.3-.1-.5 0-.5.2-1 .5-1.5.7.1-.6.1-1.1.2-1.6.1-.3 0-.4-.2-.6-.4-.3-.7-.7-1.1-1.1zm-2.2 3.4c-.5-.3-1-.5-1.5-.7-.2-.1-.4-.1-.6 0-.5.2-1 .5-1.5.7.1-.6.1-1.1.2-1.6 0-.3 0-.4-.2-.6-.3-.3-.6-.6-.9-1-.2-.2-.1-.2.1-.3.4-.1.9-.2 1.3-.2.2 0 .4-.1.5-.3.2-.5.5-.9.8-1.5.3.5.6 1 .8 1.5.1.2.2.3.5.3.5.1 1 .2 1.6.3-.4.4-.7.8-1.1 1.1-.2.2-.3.4-.2.7.1.5.2 1 .2 1.6z"
                    />
                    <path
                      class="st5"
                      d="M27.8 42c.5 0 1-.1 1.4 0 .4.2.4.7.5 1.1.3.7.6 1.5.9 2.4.3-.8.6-1.5.8-2.2 0-.1 0-.1.1-.2.5-1.3.5-1.3 1.9-1.2-.1.3-.2.5-.3.8-.5 1.3-1.1 2.6-1.6 4-.1.2-.2.3-.4.3-1.1 0-1.1 0-1.6-1.1-.5-1.2-1-2.4-1.5-3.7-.1.1-.2 0-.2-.2zm7.5 2.6v2.2c0 .2 0 .3-.3.3-1 0-1 0-1-1v-3.7c0-.3 0-.4.4-.4 1 0 1 0 1 1-.1.5-.1 1.1-.1 1.6zm.1-4c0 .4-.4.8-.8.8s-.8-.4-.8-.8.4-.8.8-.8.8.4.8.8z"
                    />
                    <path
                      d="M74.3 28.2c0 1.2-.4 2.3-1.5 3.2-1.4 1.1-3.5 1-4.8-.3-1.8-1.7-1.7-5 .3-6.5 1.9-1.6 4.7-.8 5.6 1.4.3.7.4 1.4.4 2.2zM59.5 28c0 1.6-.6 2.9-2 3.7-1.6 1-3.7.5-4.9-1-1.5-1.9-1.1-4.8.8-6.2 2-1.5 4.9-.6 5.8 1.6.1.7.3 1.3.3 1.9zm-22.9 0c0-1.6.6-2.8 2-3.7 1.7-1 3.7-.6 5 .9 1.4 1.8 1.2 4.6-.5 6-2.3 2-5.7.7-6.3-2.2-.2-.3-.2-.6-.2-1zm49.7-.2c-.2-2.6 2.4-4.7 4.8-3.9.5.2 1 .5 1.3 1 .1.1.2.3-.1.4-.1 0-.3.1-.4.2-1.9.8-3.7 1.5-5.6 2.3zM18.6 41.4h.7c.6 0 .9.4.9.9s-.3.9-.9 1h-1.5c-.2 0-.2-.1-.2-.3v-1.3c0-.2.1-.3.3-.3h.7zm20.3 2.7H38c-.2 0-.3-.1-.2-.3.2-.5.6-.8 1.2-.8s1 .3 1.2.9c.1.2 0 .3-.2.3-.4-.1-.8-.1-1.1-.1zm-14 0h-1c-.2 0-.3-.1-.2-.3.1-.5.6-.8 1.2-.8s1 .3 1.2.9c.1.2 0 .3-.2.3-.3-.1-.6-.1-1-.1z"
                      fill="#fefefe"
                    />
                  </g></svg
              ></span>
              <div class="tw-mt-12 tw-flex tw-items-center tw-gap-6 lg:tw-mt-6">
                <NuxtImg :src="review.person_photo" class="tw-h-16 tw-w-16 tw-overflow-hidden tw-rounded-full" />
                <p class="!tw-font-semibold">{{ review.person_name }}</p>
              </div>
              <div class="tw-mt-6 tw-flex tw-items-center tw-gap-2">
                <svg
                  v-for="n in review.evaluation_value"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.7375 33L11.175 22.4625L3 15.375L13.8 14.4375L18 4.5L22.2 14.4375L33 15.375L24.825 22.4625L27.2625 33L18 27.4125L8.7375 33Z"
                    fill="#EB2123"
                  />
                </svg>
              </div>
              <div class="tw-mt-4 tw-flex tw-flex-col">
                <h5 v-if="review.title" class="n-title-primary tw-line-clamp-2 tw-h-[56px]">{{ review.title }}</h5>
                <p class="tw-mt-6 tw-max-h-[250px] tw-overflow-y-auto xl:tw-max-h-[200px]">
                  {{ review.content }}
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </MotionGroup>
      <div class="tw-mt-10">
        <LibrarySliderPagination
          :swiper="swiper"
          variant="v6"
          :can-paginate-back="canPaginateBack"
          :can-paginate-next="canPaginateNext"
        />
      </div>
    </div>
  </section>

  <section
    v-else-if="variants.v3 === variant"
    class="n-section-primary"
    :style="`background-color: var(--c-${vars.backgroundColor})`"
  >
    <div class="tw-flex tw-w-full tw-flex-col tw-items-center tw-justify-center">
      <h2 class="n-title-primary tw-mb-6 lg:tw-mb-12">
        {{ vars.titleText }}
      </h2>

      <MotionGroup is="div" preset="slideVisibleBottom" :duration="700" class="tw-w-full lg:tw-max-w-full">
        <Swiper
          :pagination="false"
          :slides-per-view="1"
          :space-between="30"
          effect="fade"
          :clickable="true"
          :breakpoints="{
            320: {
              slidesPerView: 1,
              spaceBetween: 20,
            },
            1024: {
              slidesPerView: 2,
              spaceBetween: 32,
            },
          }"
          @slideChange="onSlideChange"
          @swiper="onSwiper"
          class="tw-w-full lg:tw-max-w-full"
        >
          <SwiperSlide v-for="(review, index) in reviews" :key="`testimonials-review-${index}`" class="!tw-h-auto">
            <div
              class="tw-group tw-relative tw-flex tw-h-full tw-min-h-[500px] tw-flex-col tw-bg-white tw-p-6 tw-duration-500 hover:tw-border-[var(--c-primary)] hover:tw-bg-[var(--c-input)] lg:tw-p-10"
              style="border-radius: var(--rounded)"
            >
              <span class="tw-absolute tw-w-28 tw-self-end">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 108.2 61.1">
                  <g id="Layer_1">
                    <path
                      d="M93.7 61.1H14.6C6.6 61.1 0 55.3 0 48.3V12.8C0 5.8 6.6 0 14.6 0h79.1c8 0 14.6 5.8 14.6 12.8v35.5c-.1 7-6.6 12.8-14.6 12.8z"
                      fill="#fff"
                      class="tw-duration-500 group-hover:tw-fill-[var(--c-input)]"
                    />
                    <path
                      d="M27.5 23.3H32c.2 0 .4 0 .4.3.3 2.3 0 4.5-1.1 6.5-1.5 2.7-3.9 4.3-6.9 4.7-3.9.6-7.3-.6-10.1-3.5-3.1-3.4-3.6-8.6-1.2-12.5 1.7-2.8 4.2-4.5 7.5-5.1 3.3-.6 6.3.3 8.9 2.5.2.2.2.3 0 .5-.5.5-1 1-1.5 1.6-.2.2-.3.2-.5 0-4.2-3.7-11.3-1.8-12.6 4.4-.9 4.7 2.2 8.7 6.3 9.3 2.7.4 5.1-.2 6.9-2.4.8-.9 1.1-2 1.3-3.1.1-.3-.2-.3-.4-.3h-6.2c-.4 0-.5-.1-.5-.5v-2c0-.3.1-.4.4-.4h4.8zm49.2-1.7c.3 0 .2.1.2.4v12.2c0 1.1-.2 2.2-.6 3.2-.8 2-2.3 3.1-4.4 3.5-2.2.4-4.1 0-5.8-1.5-.7-.6-1.2-1.3-1.6-2.2-.1-.2-.1-.3.1-.4.7-.3 1.4-.5 2-.8.2-.1.3-.1.5.2.4.8 1 1.5 1.9 1.8 2.3 1 4.7-.2 5.1-2.7.1-.6.1-1.2.1-1.9 0-.1 0-.1-.1-.2-.1 0-.1 0-.2.1-1.9 2.1-5.2 1.8-7.2.2-2.2-1.7-3.2-3.9-2.8-6.7.4-2.7 1.9-4.5 4.5-5.5 2-.7 3.9-.5 5.5 1 .1 0 .1.1.2.1s.1-.5.1-.6c0-.2-.1-.4.2-.4h2.3z"
                      fill="#3074f0"
                    />
                    <path
                      class="st2"
                      d="M55.5 34.9c-3.9 0-6.9-3-6.9-6.9 0-3.9 3-6.9 6.9-6.9 4.1 0 6.9 3.2 6.9 7s-2.9 6.8-6.9 6.8z"
                    />
                    <path
                      d="M33.6 28c0-3.9 3-6.9 6.9-6.9 4 0 6.9 3 6.9 7 0 3.8-3.1 6.8-6.9 6.7-4 .1-6.9-2.9-6.9-6.8zm56.5 6.9c-4.1 0-7.1-3.4-6.7-7.6.2-2 .9-3.7 2.5-4.9 3-2.3 7.1-1.5 9.1 1.8.3.5.6 1.1.8 1.7.1.3.1.4-.2.5-2 .8-4 1.6-6 2.5-.8.4-1.7.7-2.5 1-.3.1-.3.2-.1.5 1.4 2.4 4.8 2.3 6.3.2.2-.3.3-.3.6-.1.6.4 1.1.8 1.7 1.2.2.1.2.2.1.4-1.4 1.8-3.3 2.8-5.6 2.8z"
                      fill="#e63124"
                    />
                    <path
                      d="M82 24.3V34c0 .3 0 .4-.4.4h-2.2c-.4.1-.4 0-.4-.4V14.6c0-.4.1-.5.5-.5h2.1c.3 0 .5.1.5.4-.1 3.4-.1 6.6-.1 9.8z"
                      fill="#249a41"
                    />
                    <path
                      class="st5"
                      d="M21.8 47.1h-1.5c-.2 0-.3-.1-.4-.3-.3-.6-.7-1.3-1.1-1.9-.2-.3-1-.5-1.2-.3-.1.1-.1.2-.1.3v1.9c0 .2-.1.3-.3.3-1.2 0-1.2 0-1.2-1.2v-5.5c0-.3.1-.4.4-.4h3.1c.9 0 1.7.4 2 1.3.3.9.3 1.7-.4 2.5-.2.2-.4.4-.7.4-.3.1-.3.2-.1.4.6.9 1 1.7 1.5 2.5zm22.5-1.8c.3-1 .6-1.9.9-2.9.1-.3.2-.4.5-.4.8 0 .8 0 1.1.8.3.8.6 1.7.9 2.6.3-1.1.6-2 .8-3 .1-.3.2-.4.5-.4 1 0 1 0 .7 1-.4 1.3-.8 2.5-1.2 3.8-.1.3-.2.4-.5.4-1.1 0-1.1 0-1.4-1-.2-.8-.5-1.6-.8-2.4-.2.7-.4 1.3-.6 1.9-.1.4-.3.8-.4 1.3-.1.3-.2.3-.5.3-1.1 0-1.1 0-1.4-1-.4-1.3-.8-2.6-1.2-4v-.1c1.3-.1 1.3-.1 1.7 1.1.4.6.6 1.3.9 2-.1 0-.1 0 0 0zm-4.8-.3H38c-.3 0-.3.1-.2.4.3.7 1 1 1.8.8.2 0 .3-.1.4-.2.5-.2.5-.2.9.3.2.3.1.4-.1.5-1 .5-2 .7-3 .2-1-.4-1.6-1.4-1.5-2.6 0-1.1.7-2 1.7-2.4 1-.4 2.1-.1 2.8.6.5.6.7 1.3.7 2.1 0 .2-.1.3-.3.3h-1.7zm-13.9 0H24c-.3 0-.3.1-.2.3.3.7 1 1.1 1.8.9.2 0 .4-.2.6-.2.1 0 .3-.3.4-.1.2.2.4.5.5.8l-.2.2c-.9.7-2.6.7-3.6.1-1-.7-1.3-2-.9-3.2.4-1.2 1.6-1.9 2.8-1.8 1.2.1 2.1 1.1 2.2 2.3.1.8.1.8-.7.8-.3-.1-.7-.1-1.1-.1zm28.5-1.5c-.4-.3-.8-.5-1.3-.6-.2 0-.5 0-.7.1-.2.1-.4.2-.3.4 0 .2.2.3.4.3.6.2 1.2.2 1.7.5.6.3.9.7 1 1.4 0 .7-.3 1.1-.9 1.4-.1.1-.3.1-.4.1-1 .2-2 .1-2.9-.4-.3-.2-.4-.3-.2-.6.4-.5.3-.5.9-.3.5.3 1 .4 1.6.3.3-.1.5-.2.5-.5s-.2-.4-.5-.5c-.6-.2-1.1-.2-1.7-.4-.5-.2-.9-.6-.9-1.2-.1-.6.2-1.1.7-1.4.3-.2.6-.3 1-.3.8-.1 1.6.1 2.3.5.2.1.3.2.1.5-.2.2-.3.4-.4.7z"
                    />
                    <path
                      class="st2"
                      d="M85.5 47.1c.1-.6.1-1.1.2-1.6.1-.3 0-.4-.2-.6-.4-.4-.7-.7-1.1-1.2.6-.1 1.1-.2 1.6-.3.2 0 .3-.1.4-.3.3-.5.5-.9.8-1.5.3.5.5.9.8 1.4.1.2.3.4.6.4.5.1 1 .2 1.6.3-.4.4-.7.8-1.1 1.2-.2.2-.3.4-.2.6.1.5.1 1 .2 1.6-.5-.3-1-.5-1.5-.7-.2-.1-.3-.1-.5 0-.6.2-1.1.5-1.6.7zm-2.2-3.4c-.4.4-.8.8-1.1 1.2-.2.2-.2.3-.2.6.1.5.1 1.1.2 1.6-.4-.2-.8-.3-1.1-.5-.4-.3-.8-.3-1.3 0-.3.2-.7.3-1.1.5.1-.6.1-1.1.2-1.7 0-.2 0-.4-.2-.5-.4-.4-.7-.8-1.1-1.2.6-.1 1.1-.2 1.6-.3.2 0 .4-.2.5-.4.2-.5.5-.9.8-1.4.3.5.5 1 .8 1.4.1.2.2.3.5.4l1.5.3zm-12.5 0c.6-.1 1.1-.2 1.6-.3.2 0 .4-.1.5-.3.2-.5.5-.9.8-1.4.3.5.5.9.8 1.4.1.2.3.4.6.4.5.1 1 .2 1.6.3-.4.4-.8.8-1.1 1.2-.2.2-.2.3-.2.6.1.5.1 1.1.2 1.6-.5-.2-1-.5-1.5-.7-.2-.1-.4-.1-.6 0-.5.2-.9.4-1.5.7.1-.6.1-1.1.2-1.7 0-.2 0-.4-.2-.5-.5-.4-.8-.8-1.2-1.3zm-6.8 0c.6-.1 1.1-.2 1.6-.3.2 0 .3-.1.4-.3.3-.5.5-.9.8-1.5.3.5.5 1 .8 1.4.1.2.2.3.5.3.5.1 1 .2 1.6.3-.4.4-.7.8-1.1 1.2-.2.2-.3.4-.2.6.1.5.1 1 .2 1.6-.5-.2-1-.5-1.5-.7-.2-.1-.3-.1-.5 0-.5.2-1 .5-1.5.7.1-.6.1-1.1.2-1.6.1-.3 0-.4-.2-.6-.4-.3-.7-.7-1.1-1.1zm-2.2 3.4c-.5-.3-1-.5-1.5-.7-.2-.1-.4-.1-.6 0-.5.2-1 .5-1.5.7.1-.6.1-1.1.2-1.6 0-.3 0-.4-.2-.6-.3-.3-.6-.6-.9-1-.2-.2-.1-.2.1-.3.4-.1.9-.2 1.3-.2.2 0 .4-.1.5-.3.2-.5.5-.9.8-1.5.3.5.6 1 .8 1.5.1.2.2.3.5.3.5.1 1 .2 1.6.3-.4.4-.7.8-1.1 1.1-.2.2-.3.4-.2.7.1.5.2 1 .2 1.6z"
                    />
                    <path
                      class="st5"
                      d="M27.8 42c.5 0 1-.1 1.4 0 .4.2.4.7.5 1.1.3.7.6 1.5.9 2.4.3-.8.6-1.5.8-2.2 0-.1 0-.1.1-.2.5-1.3.5-1.3 1.9-1.2-.1.3-.2.5-.3.8-.5 1.3-1.1 2.6-1.6 4-.1.2-.2.3-.4.3-1.1 0-1.1 0-1.6-1.1-.5-1.2-1-2.4-1.5-3.7-.1.1-.2 0-.2-.2zm7.5 2.6v2.2c0 .2 0 .3-.3.3-1 0-1 0-1-1v-3.7c0-.3 0-.4.4-.4 1 0 1 0 1 1-.1.5-.1 1.1-.1 1.6zm.1-4c0 .4-.4.8-.8.8s-.8-.4-.8-.8.4-.8.8-.8.8.4.8.8z"
                    />
                    <path
                      d="M74.3 28.2c0 1.2-.4 2.3-1.5 3.2-1.4 1.1-3.5 1-4.8-.3-1.8-1.7-1.7-5 .3-6.5 1.9-1.6 4.7-.8 5.6 1.4.3.7.4 1.4.4 2.2zM59.5 28c0 1.6-.6 2.9-2 3.7-1.6 1-3.7.5-4.9-1-1.5-1.9-1.1-4.8.8-6.2 2-1.5 4.9-.6 5.8 1.6.1.7.3 1.3.3 1.9zm-22.9 0c0-1.6.6-2.8 2-3.7 1.7-1 3.7-.6 5 .9 1.4 1.8 1.2 4.6-.5 6-2.3 2-5.7.7-6.3-2.2-.2-.3-.2-.6-.2-1zm49.7-.2c-.2-2.6 2.4-4.7 4.8-3.9.5.2 1 .5 1.3 1 .1.1.2.3-.1.4-.1 0-.3.1-.4.2-1.9.8-3.7 1.5-5.6 2.3zM18.6 41.4h.7c.6 0 .9.4.9.9s-.3.9-.9 1h-1.5c-.2 0-.2-.1-.2-.3v-1.3c0-.2.1-.3.3-.3h.7zm20.3 2.7H38c-.2 0-.3-.1-.2-.3.2-.5.6-.8 1.2-.8s1 .3 1.2.9c.1.2 0 .3-.2.3-.4-.1-.8-.1-1.1-.1zm-14 0h-1c-.2 0-.3-.1-.2-.3.1-.5.6-.8 1.2-.8s1 .3 1.2.9c.1.2 0 .3-.2.3-.3-.1-.6-.1-1-.1z"
                      fill="#fefefe"
                    />
                  </g></svg
              ></span>
              <div class="tw-mt-12 tw-flex tw-items-center tw-gap-6 lg:tw-mt-6">
                <NuxtImg :src="review.person_photo" class="tw-h-16 tw-w-16 tw-overflow-hidden tw-rounded-full" />
                <h6 class="!tw-font-semibold">{{ review.person_name }}</h6>
              </div>
              <div class="tw-mt-6 tw-flex tw-items-center tw-gap-2">
                <svg
                  v-for="n in review.evaluation_value"
                  width="32"
                  height="32"
                  viewBox="0 0 32 32"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.7375 33L11.175 22.4625L3 15.375L13.8 14.4375L18 4.5L22.2 14.4375L33 15.375L24.825 22.4625L27.2625 33L18 27.4125L8.7375 33Z"
                    fill="var(--c-secondary)"
                  />
                </svg>
              </div>
              <div class="tw-mt-4 tw-flex tw-flex-col">
                <h4 v-if="review.title" class="tw-line-clamp-2 tw-h-[56px]">{{ review.title }}</h4>
                <p class="tw-mt-6 tw-max-h-[250px] tw-overflow-y-auto xl:tw-max-h-[200px]">
                  {{ review.content }}
                </p>
              </div>
            </div>
          </SwiperSlide>
        </Swiper>
      </MotionGroup>
      <div class="controls">
        <div
          data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569daf"
          class="slide-left-arrow w-slider-arrow-left"
          :isDisabled="!canPaginateBack"
          @click="() => swiper.slidePrev()"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M16.011 3.49956C16.1418 3.6335 16.2151 3.81332 16.2151 4.00056C16.2151 4.18781 16.1418 4.36762 16.011 4.50156L8.70149 12.0001L16.011 19.4971C16.1418 19.631 16.2151 19.8108 16.2151 19.9981C16.2151 20.1853 16.1418 20.3651 16.011 20.4991C15.9474 20.5644 15.8714 20.6163 15.7874 20.6517C15.7034 20.6872 15.6132 20.7054 15.522 20.7054C15.4308 20.7054 15.3406 20.6872 15.2566 20.6517C15.1726 20.6163 15.0966 20.5644 15.033 20.4991L7.25999 12.5236C7.12347 12.3835 7.04706 12.1957 7.04706 12.0001C7.04706 11.8045 7.12347 11.6166 7.25999 11.4766L15.033 3.50106C15.0966 3.43575 15.1726 3.38383 15.2566 3.34839C15.3406 3.31294 15.4308 3.29468 15.522 3.29468C15.6132 3.29468 15.7034 3.31294 15.7874 3.34839C15.8714 3.38383 15.9474 3.43575 16.011 3.50106V3.49956Z"
              fill="#6EADAB"
            />
          </svg>
          <div class="slide-circle slider-circle-transform"></div>
        </div>
        <div
          data-w-id="080a9ca2-7a2d-2ca3-3b22-f42b27569db1"
          class="slide-right-arrow w-slider-arrow-right"
          :isDisabled="!canPaginateNext"
          @click="() => swiper.slideNext()"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M7.98901 3.49956C7.85817 3.6335 7.78491 3.81332 7.78491 4.00056C7.78491 4.18781 7.85817 4.36762 7.98901 4.50156L15.2985 12.0001L7.98901 19.4971C7.85817 19.631 7.78491 19.8108 7.78491 19.9981C7.78491 20.1853 7.85817 20.3651 7.98901 20.4991C8.0526 20.5644 8.12864 20.6163 8.21263 20.6517C8.29661 20.6872 8.38685 20.7054 8.47801 20.7054C8.56917 20.7054 8.65941 20.6872 8.74339 20.6517C8.82738 20.6163 8.90342 20.5644 8.96701 20.4991L16.74 12.5236C16.8765 12.3835 16.9529 12.1957 16.9529 12.0001C16.9529 11.8045 16.8765 11.6166 16.74 11.4766L8.96701 3.50106C8.90342 3.43575 8.82738 3.38383 8.74339 3.34839C8.65941 3.31294 8.56917 3.29468 8.47801 3.29468C8.38685 3.29468 8.29661 3.31294 8.21263 3.34839C8.12864 3.38383 8.0526 3.43575 7.98901 3.50106V3.49956Z"
              fill="#6EADAB"
            />
          </svg>
          <div class="slide-circle right"></div>
        </div>
      </div>
    </div>
  </section>
</template>

<script lang="ts">
import { ComponentMixin } from '~/mixins/component.mixin';

export default defineNuxtComponent({
  name: 'Testimonials',

  mixins: [ComponentMixin],

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,
      reviews: null,
      variants: {
        v1: 'v1',
        v2: 'v2',
        v3: 'v3',
        GoogleReviews: 'GoogleReviews',
      },
    };
  },

  created() {
    const parsedReviews = this.parseFormV2(this.vars.googleReviews);
    this.reviews = parsedReviews?.reviews;
  },
  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },
  },

  computed: {
    variant() {
      return useVariant(this.component);
    },

    computedBreakpoints() {
      const baseBreakpoints = {
        320: {
          slidesPerView: 1,
          spaceBetween: 20,
        },
        1024: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
      };

      if (this.variants.variant === this.variants.GoogleReviews) {
        baseBreakpoints[1336] = {
          slidesPerView: 2,
          spaceBetween: 24,
        };
      } else if (this.variants.variant === this.variants.v1) {
        baseBreakpoints[1336] = {
          slidesPerView: 3,
          spaceBetween: 24,
        };
      }

      return baseBreakpoints;
    },
  },

  mounted() {
    this.onSlideChange();
  },
});
</script>

<style scoped>
::-webkit-scrollbar {
  width: 2px;
}

::-webkit-scrollbar-track {
  background: #f1f1f1;
}

/* Handle */
::-webkit-scrollbar-thumb {
  -webkit-border-radius: 10px;
  border-radius: 10px;
  background: var(--c-primary);
}
::-webkit-scrollbar-thumb:window-inactive {
  display: none;
}

.st2 {
  fill: #fbaf02;
}
.st5 {
  fill: #6d6e71;
}
</style>
